import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteHarvestConfig } from "../api/harvestApi";

export function useDeleteHarvestConfig() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => deleteHarvestConfig(),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["harvest", "config"] }),
  });
}
